import React from "react";
import { Icon, VStack } from "@chakra-ui/react";
import { IoLockClosed } from "react-icons/io5";
import { TextInput, Form } from "components";
import { useOnline, useAuthenticate, useAuth } from "duck";
import { Types, hooks, utils } from "./duck";

const PinForm: React.FC = () => {
  const [, setConfig] = useAuth();
  const online = useOnline();
  const onSubmit = hooks.useLogin();

  useAuthenticate({ skip: !online, setConfig });

  return (
    <Form<Types.FormValues>
      width="21.25rem"
      {...utils.getValidation()}
      onSubmit={onSubmit}
    >
      {({ setValue }) => (
        <VStack spacing={6}>
          <TextInput
            type="password"
            numeric
            name="pin"
            label="PIN"
            labelHidden
            placeholder="PIN"
            inputLeftElementProps={{
              children: <Icon as={IoLockClosed} color="gray.400" w={5} h={5} />
            }}
            onChange={e => {
              setValue("pin", e.target.value, {
                shouldTouch: true,
                shouldValidate: true,
                shouldDirty: true
              });
            }}
          />
          <Form.Controls submitProps={{ w: "full" }} submitText="Login" />
        </VStack>
      )}
    </Form>
  );
};

export default PinForm;
